import { usePartnerMissionStore } from "../../../../stores/Cac/Partner/partnerMission";

const PopupLimitMission = () => {

  // Store
  const { setErrorLimitMission } = usePartnerMissionStore();

  return (
    <>
      <div className="fixed inset-0 z-50 flex min-w-full items-center justify-center overflow-y-auto p-3 outline-hidden focus:outline-hidden sm:p-6">
        <div className="relative mx-auto w-full max-w-lg">
          {/*content*/}
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-hidden focus:outline-hidden">
            {/*header*/}
            <div className="flex items-center justify-center p-5 border-b border-solid border-slate-200 rounded-t">
              <h3 className="text-center text-xl font-semibold text-grey-trio md:text-3xl">
                Nombres de missions atteint
              </h3>
            </div>
            {/*body*/}
            <div className="text-sm md:text-base text-center p-5 text-grey-trio">
                Vous avez atteint le nombre maximum de missions actives autorisées. Veuillez contacter notre support à l'adresse : <br />
                <span className="italic underline font-extrabold">support@trionode.mc</span>
                
            </div>
            {/*footer*/}
            <div className="flex items-center justify-end p-4 border-t border-solid border-slate-200 rounded-b">
              <button
                className="text-white bg-linear-to-r from-light-lavender via-light-lavender to-dark-lavender hover:bg-linear-to-br font-medium rounded-lg 2xl:text-lg text-base  px-5 py-2.5 text-center me-2 uppercase  shadow-sm hover:shadow-lg outline-hidden  ease-linear transition-all duration-150"
                type="button"
                onClick={() => {
                  setErrorLimitMission(false);
                }}
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  )
}

export default PopupLimitMission
